import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import UserPermissions from "@/helpers/userPermission";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/appsLogs";
import kioskReadOnly from "@/mixins/kioskReadOnly";

import "@/styles/app.scss";
import "@/styles/dashboard-shared.css";
import i18n from "./i18n";

Vue.config.productionTip = false;

// Global mixin: adds $isKioskSession to every component
// Usage in templates: v-if="!$isKioskSession"
Vue.mixin(kioskReadOnly);

const files = require.context("./components/global", true, /\.vue$/i);
files.keys().map((key) => {
  Vue.component(
    files(key).default.name ?? key.split("/").pop().split(".")[0],
    files(key).default
  );
});

const { host } = window.location;
const isCustomApp =
  !host.startsWith("localhost") &&
  !host.startsWith("127.0.0.1") &&
  !host.startsWith("app.switchq");

if (isCustomApp) {
  localStorage.setItem("customApp", true);
} else {
  localStorage.removeItem("customApp");
}
Vue.use(UserPermissions, { store });

// ── Hydrate user preferences from localStorage before mounting ──────────────
// This runs synchronously so theme/viewMode are ready for every component's
// first render. The Vuetify dark-mode flag is applied right here.
store.dispatch("preferences/hydrate");
const savedTheme = store.getters["preferences/theme"];
vuetify.framework.theme.dark = savedTheme === "dark";

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
